import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

import Tooltip from 'components/common/Tooltip';
import IconRural from 'components/icons/IconRural';

import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

const styles = theme => ({
  tableRow: {
    height: 24,
  },
  tableCell: {
    border: 'none',
    padding: 0,
    fontSize: pxToRem(14),
    letterSpacing: pxToEm(0.5, 14),
    lineHeight: pxToEm(24, 14),
    '&:first-child': {
      width: 110,
      color: theme.palette.grey[700],
      paddingRight: 15,
      paddingLeft: 0,
    },
    '&:last-child': {
      paddingRight: 0,
    },
  },
  tooltip: {
    verticalAlign: 'top',
  },
  iconRural: {
    width: 24,
    height: 24,
    marginRight: 8,
    marginTop: -4,
    color: theme.palette.primary[500],
  },
});

const FacilitiesListItemInformation = props => (
  <Table>
    <TableBody>
      <TableRow className={props.classes.tableRow}>
        <TableCell className={props.classes.tableCell}>
          Mobile Phone
        </TableCell>
        <TableCell
          className={props.classes.tableCell}
        >
          {props['Company Contact'] && props['Company Contact']['Phone Number'] ? props['Company Contact']['Phone Number'] : ''}
        </TableCell>
      </TableRow>
      <TableRow className={props.classes.tableRow}>
        <TableCell className={props.classes.tableCell}>
          Fax
        </TableCell>
        <TableCell
          className={props.classes.tableCell}
        >
          {props['Company Contact'] && props['Company Contact'].Fax ? props['Company Contact'].Fax : ''}
        </TableCell>
      </TableRow>
      <TableRow className={props.classes.tableRow}>
        <TableCell className={props.classes.tableCell}>
          Address
        </TableCell>
        <TableCell
          className={props.classes.tableCell}
        >
          {(props['Company Address'] && props['Company Address'].ID) &&
            <Fragment>
              {props['Company Address']['Is Rural'] &&
                <Tooltip
                  className={props.classes.tooltip}
                  content={
                    <Typography>
                      Rural Address
                    </Typography>
                  }
                  placement="top"
                >
                  <IconRural className={props.classes.iconRural} />
                </Tooltip>
              }
              {props['Company Address'].Suite
                ? `${props['Company Address'].Street} ${props['Company Address'].Suite}, ${props['Company Address'].City}, ${props['Company Address'].State}, ${props['Company Address']['Zip Code']}`
                : `${props['Company Address'].Street}, ${props['Company Address'].City}, ${props['Company Address'].State}, ${props['Company Address']['Zip Code']}`}
            </Fragment>
          }
        </TableCell>
      </TableRow>
      <TableRow className={props.classes.tableRow}>
        <TableCell className={props.classes.tableCell}>
          Time Zone
        </TableCell>
        <TableCell
          className={props.classes.tableCell}
        >
          {props['Company Address'] && props['Company Address']['Time Zone'] ? props['Company Address']['Time Zone'] : ''}
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
);

FacilitiesListItemInformation.propTypes = {
  classes: PropTypes.shape({
    tableCell: PropTypes.string.isRequired,
    tableRow: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(FacilitiesListItemInformation);



// WEBPACK FOOTER //
// ./src/components/settings/FacilitiesList/FacilitiesListItemInformation.js